var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 372,
    viewBox: "0 0 338 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0.376953 120.906C0.376953 36.6424 84.9461 -21.379 163.563 8.94616L247.457 41.3067C355.515 82.9882 369.113 230.374 270.505 291.122L166.549 355.166C93.927 399.905 0.376953 347.66 0.376953 262.363V120.906Z",
    fill: "#DD2F29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialbg);
export default __webpack_public_path__ + "static/media/testimonialbg.554bb16017a154783b6ae152bc875978.svg";
export { ForwardRef as ReactComponent };